module.exports = __webpack_public_path__ + "img/curtain-back-desktop.49e045d4.jpg";